import {type FunctionalComponent, h} from '@stencil/core';
import {getAppName} from '../utils/utils';
import type {Strategies} from '../../../../../strategies/Strategies';
import {CtaWidgetsRow} from './cta-widgets-row';
import type {IWidgetRequestData} from '../../../../../widgets/offsites-widget/offsites-widget-v4/types/offsites-widget-v4.types';

interface IMySeDashboardWidgetsMiddle {
  labelProvider: CallableFunction;
  isExchangeVisible?: boolean;
  isOffsitesVisible?: boolean;
  hasCtaProductSelector?: boolean;
  country?: string;
  language?: string;
  term?: string;
  tabName?: string;
  analyticsTabName?: string;
  brand?: string;
  isOffsitesWidget?: boolean;
  offsiteBannersManagerRequestData?: IWidgetRequestData;
  relatedProductName?: string;
  strategies: Strategies;
}

export const MySeDashboardWidgetsMiddle: FunctionalComponent<
  IMySeDashboardWidgetsMiddle
> = (props) => {

    const {
      country,
      language,
      term,
      tabName,
      analyticsTabName,
      brand,
      labelProvider,
      isOffsitesWidget,
      offsiteBannersManagerRequestData,
      relatedProductName,
      strategies
    } = props;

    return ([<div class="dashboard__tiles dashboard__tiles--myse widget-offset-bottom-myse"
    >
      <CtaWidgetsRow
        labelProvider={labelProvider}
        country={country}
        language={language}
        strategies={strategies}
      />
    </div>,

    isOffsitesWidget && !offsiteBannersManagerRequestData &&
      <div class="dashboard__tile--full-width">
        <div class="offsites-container">
          <uiaas-offsites-widget-v4
            term={term}
            country={country}
            language={language}
            is-dashboard-view={true}
            brand={brand}
            tab-name={tabName}
            analytics-tab-name={analyticsTabName}
            relatedProductName={relatedProductName}
          />
        </div>
      </div>,
    isOffsitesWidget && offsiteBannersManagerRequestData &&
          <div class="dashboard__tile--full-width">
            <div class="offsites-container">
              <uiaas-offsites-widget-v3
                isDashboard={true}
                computedPlacement={true} // should be variable 
                isRtl={false} // should be variable or removed (default value is false)
                analyticsTabName={analyticsTabName}
                tabName={tabName}
                term={term}
                brand={brand}
                offsiteBannersManagerRequestData={offsiteBannersManagerRequestData}
                labelProvider={(e, f) => labelProvider(e, f)}
                country={country}
                language={language}
              />
            </div>
          </div>]);
};
